import React from 'react';
import { ThemeProvider } from '@mui/system';
import { Tooltip, IconButton } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import * as DefaultRoutes from '@Routes/DefaultRoutes';
import { REGULATORY_EXEMPTION_REQUESTS } from '@API/APIRoutes';
import GenericRnDListing from '@Pages/RnDMember/GenericRnDListing/GenericRnDListing';
import { buildExemptionColumns, DEFAULT_EXEMPTION_COLUMN_VISIBILITY } from './exemptionColumns';

const PAGE_TITLE = 'My Regulatory Exemptions';
const ERROR_MESSAGE = 'Failed to fetch exemption requests. Trying again!';
const TOOLTIP_ADD_ASSESSMENT = 'Add Local Risk Assessment';

/**
 * The Regulatory member's Exemptions Hub is an action queue: it lists only the exemption requests
 * on their own exit requests that are waiting for their Local Regulatory Risk Assessment, oldest
 * first. Requests they have already forwarded are followed up from the exit request itself.
 * The backend (GET /exit-plans/exemptions/regulatory) applies the same filter.
 */
function RegulatoryExemptionsListing() {
  // Status and approval progress are identical on every row of an action queue, so they are hidden
  // by default; the user can still switch them on from the column toolbar.
  const columns = buildExemptionColumns();

  const renderActions = (params, navigate, theme) => (
    <ThemeProvider theme={theme}>
      <Tooltip title={TOOLTIP_ADD_ASSESSMENT}>
        <IconButton
          color="warning"
          size="small"
          onClick={() => navigate(DefaultRoutes.exemptionInfo.replace(':planId', params.row.id))}
        >
          <EditNoteIcon />
        </IconButton>
      </Tooltip>
    </ThemeProvider>
  );

  return (
    <GenericRnDListing
      pageTitle={PAGE_TITLE}
      PageIcon={<ReceiptLongIcon color="white" fontSize="large" />}
      iconColor="warning.main"
      apiRoute={REGULATORY_EXEMPTION_REQUESTS}
      columns={columns}
      renderActions={renderActions}
      errorMessage={ERROR_MESSAGE}
      initialColumnVisibilityModel={DEFAULT_EXEMPTION_COLUMN_VISIBILITY}
      serverPagination={false}
      getRowId={(row) => row.id}
    />
  );
}

export default RegulatoryExemptionsListing;
